import React, { useState, useEffect, useCallback } from 'react';
import Plot from 'react-plotly.js';
import QbFortyTimeValueToColorHelper from '../Helpers/QbFortyTimeValueToColorHelper';
import RbFortyTimeValueToColorHelper from '../Helpers/RbFortyTimeValueToColorHelper';
import WrFortyTimeValueToColorHelper from '../Helpers/WrFortyTimeValueToColorHelper';
import TeFortyTimeValueToColorHelper from '../Helpers/TeFortyTimeValueToColorHelper';
import { useTheme } from '../../contexts/ThemeContext';

function getChartWidth() {
	return window.innerWidth < 640 ? 325 : 475;
}

function getColorHelperByPosition(position) {
	switch (position.toLowerCase()) {
		case 'quarterback':
			return QbFortyTimeValueToColorHelper;
		case 'running back':
			return RbFortyTimeValueToColorHelper;
		case 'wide receiver':
			return WrFortyTimeValueToColorHelper;
		case 'tight end':
			return TeFortyTimeValueToColorHelper;
		default:
			return () => '#eeeeee';
	}
}

export default function HorizontalBarChart({
	title,
	position,
	bar1Label,
	bar1Value,
	bar2Label,
	bar2Value,
	lowerRange,
	upperRange
}) {
	const { isDarkMode } = useTheme();
	const [width, setWidth] = useState(getChartWidth());

	const updateDimensions = useCallback(() => {
		setWidth(getChartWidth());
	}, []);

	useEffect(() => {
		window.addEventListener('resize', updateDimensions);
		return () => window.removeEventListener('resize', updateDimensions);
	}, [updateDimensions]);

	const colorHelper = getColorHelperByPosition(position);
	const chartTextColor = isDarkMode ? '#fefefe' : '#000';
	const secondaryBarColor = isDarkMode ? '#374151' : '#eeeeee';
	const axisLineColor = isDarkMode ? '#4b5563' : '#000';

	return (
		<Plot
			key={isDarkMode ? 'dark' : 'light'}
			data={[
				{
					y: [bar1Label, bar2Label],
					x: [bar1Value, bar2Value],
					type: 'bar',
					orientation: 'h',
					marker: {
						color: [colorHelper(bar1Value), secondaryBarColor]
					},
					text: [bar1Value, bar2Value],
					textposition: 'outside',
					textfont: {
						color: chartTextColor
					}
				}
			]}
			layout={{
				paper_bgcolor: 'transparent',
				plot_bgcolor: 'transparent',
				title: {
					text: title ? title : '',
					font: {
						size: 18,
						color: chartTextColor
					}
				},
				font: {
					color: chartTextColor
				},
				height: 225,
				width,
				tickmode: 'auto',
				xaxis: {
					title: 'Time (sec.)',
					range: [lowerRange, upperRange],
					showline: true,
					showgrid: false,
					tickfont: { color: chartTextColor },
					titlefont: { color: chartTextColor },
					linecolor: axisLineColor
				},
				yaxis: {
					automargin: true,
					ticklen: 10,
					tickcolor: 'rgba(0,0,0,0)',
					showline: true,
					tickfont: { color: chartTextColor },
					linecolor: axisLineColor
				},
				margin: { l: 50, r: 50, t: 30, b: 50 }
			}}
			config={{
				displayModeBar: false
			}}
		/>
	);
}
